// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-oXOKx2S0 clearfix","box_r":"box_r-17X3ndVK","d_box":"d_box-3pN2RTEZ"};